<template>
  <div>
    <modal-padrao
      ref="modal-mensagem"
      :titulo="$t('modulos.orcamentos.formulario.mensagem')"
      max-width="80%"
      :titulo-ok="$t('geral.botoes.confirmar')"
      @ok="salvar"
    >
      <tabela-padrao-prime-vue
        ref="tabela"
        v-model="selecionados"
        :dados="tabela.dados"
        filtros-com-colunas
        class="mt-6"
        filtro-global-focus
        :colunas="tabela.colunas"
        :por-pagina="tabela.porPagina"
        :quantidade-itens="tabela.quantidadeItens"
        :quantidade-paginas="tabela.quantidadePaginas"
        :mostrar-seletor="true"
        :selecionar-apenas-um="true"
        @paginar="listar"
        @filtrarGlobal="listar"
        @filtroGlobal="(v) => (filtroAplicado.filter = v)"
        @fechar-modal-click-linha="() => $emit('fechar-modal-click-linha')"
      >
        <template #seletor="{ slotProps }">
          <v-checkbox
            v-model="input"
            :disabled="slotProps.data.flagObrigatorio"
            :value="
              slotProps.data.flagObrigatorio ||
              selecionados.includes(slotProps.data)
            "
            class="thin-border-checkbox"
            @input="selecionarTabela(slotProps.data, slotProps.data.isSelected)"
          />
        </template>
        <template v-slot:item.info="{ item }">
          <Button
            style="
              background-color: rgba(0, 255, 255, 0);
              color: inherit;
              border-color: rgba(255, 255, 255, 0);
            "
            type="button"
            icon="pi pi-search"
            aria:haspopup="true"
            aria-controls="overlay_panel"
            @click="toggle($event, item.item)"
          />
        </template>
      </tabela-padrao-prime-vue>
      <OverlayPanel
        id="overlay_panel"
        ref="op"
        append-to="body"
        style="
          width: 800px;
          min-height: 100px;
          overflow-y: scroll;
          max-height: 150px;
        "
      >
        <DataTable
          :value="dadosOverlayPanel"
          striped-rows
          class="p-datatable-sm oculta-thead"
          :rows="4"
        >
          <Column field="coluna1" header="" :styles="{ width: '10%' }">
            <template #body="slotProps">
              <strong>
                {{ slotProps.data.coluna1 }}
              </strong>
            </template>
          </Column>
          <Column field="coluna2" header="" />
        </DataTable>
      </OverlayPanel>
    </modal-padrao>
    <v-combobox
      v-model="selecionados"
      :items="tabela.dados"
      item-text="nome"
      item-value="id"
      outlined
      readonly
      dense
      hide-details
      append-icon="pi pi-search"
      @click="abrirModal"
      @mousedown="abrirModal"
      @mouseup="abrirModal"
    />
  </div>
</template>
<script>
import CampoAdicionalService from '@common/services/cadastros/CampoAdicionalService.js';
import helpers from '@/common/utils/helpers';
import _ from 'lodash';
export default {
  props: {
    form: {},
    dados: {},
    criterio: {},
    Entidade: null,
  },
  data() {
    return {
      keyAtualiza: 1,
      expanded: [],
      dadosOverlayPanel: [],
      singleExpand: false,
      filtro: {},
      filtroAplicado: { filter: '' },
      selecionados: [],
      tabela: {
        dados: [],
        colunas: [
          {
            value: 'nome',
            text: this.$t('modulos.mensagem_orcamento.tabela.nome'),
            sortable: true,
          },
        ],
        quantidadeItens: 0,
        quantidadePaginas: 0,
        paginaAtual: 1,
        porPagina: 10,
      },
    };
  },
  watch: {
    async selecionados(valor) {
      let criterios = this.$store.getters['criterios/getCriterios'];
      const itemEncontrado = criterios.find(
        (item) => item.sequencia === this.criterio.sequencia
      );

      if (itemEncontrado && valor.id) {
        (itemEncontrado.campoAdicionalParticipanteId = valor.id),
          (itemEncontrado.campoAdicionalParticipante = {
            id: valor.id,
            nome: valor.nome,
          });

        this.selecionados = valor.nome;
        this.$store.dispatch('criterios/updateCriterio', {
          updatedCriterio: itemEncontrado,
        });
      }
    },
  },
  async mounted() {
    this.$nextTick(() => {
      this.listar();
    });
    await this.setup();
  },
  methods: {
    async setup() {
      let criterios = await this.$store.getters['criterios/getCriterios'];
      const itemEncontrado = await criterios.find(
        (item) => item.sequencia === this.criterio.sequencia
      );

      if (itemEncontrado && itemEncontrado.campoAdicionalInstrumento?.nome) {
        this.selecionados = itemEncontrado.campoAdicionalInstrumento.nome;
      }
    },
    toggle(event, info) {
      this.$refs.op.toggle(event);
      this.dadosOverlayPanel = [
        {
          coluna1: 'Descrição:',
          coluna2: info.descricao,
        },
      ];
    },
    abrirModal() {
      this.keyAtualiza++;
      this.$refs['modal-mensagem'].abrirModal();
      this.listar(this.tabela.paginaAtual);
    },
    filtrar: function () {
      this.filtroAplicado = _.cloneDeep(this.filtro);
      this.listar(this.tabela.paginaAtual);
    },
    listar: async function (paginaAtual = 1, porPagina = 10) {
      this.selecionados = [];
      await this.verificarObrigatorios();
      let parametros = {
        page: paginaAtual,
        amountPerPage: porPagina,
        ...(this.Entidade ? { Entidade: this.Entidade } : {}),
        ...helpers.formattingParameters(this.filtroAplicado),
      };
      CampoAdicionalService.listar(parametros)
        .then((res) => {
          this.tabela.dados = res.data.items;
          this.tabela.quantidadeItens = res.data.totalItems;
          this.tabela.quantidadePaginas = res.data.totalPages;
          this.tabela.paginaAtual = paginaAtual;
          this.tabela.porPagina = porPagina;
        })
        .finally(() => {
          this.form.orcamentoMensagem?.forEach((mensagem) => {
            this.selecionados.push({
              ...mensagem,
              id: mensagem.mensagemOrcamentoId,
            });
          });
        });
    },
    verificarObrigatorios: async function () {},
    salvar: function () {
      this.$emit('novaMensagem', this.selecionados);
      this.$refs['modal-mensagem'].fecharModal();
    },
    selecionarTabela: function (item, selecionado) {
      if (!selecionado) {
        this.selecionados.splice(
          this.selecionados.indexOf(
            this.selecionados.find((el) => el.id == item.id)
          ),
          1
        );
      } else {
        this.selecionados.push(item);
      }
    },
    podeSelecionar(item) {
      return !item.flagObrigatorio;
    },
  },
};
</script>
